import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'spaq-message-state',
	template: `
		<div>
			<div *ngIf="hasSuccess || hasError || hasWarning" class="p-3 mb-4 alert" [ngClass]="ngClass">
				{{ findMessage }}
			</div>
		</div>
	`,
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageStateComponent {
	get findMessage() {
		if (this.message && this.message.message) {
			return this.message.message;
		}
		if (this.message && typeof this.message === 'object') {
			return JSON.stringify(this.message);
		}
		if (this.message && this.message !== '') {
			return this.message;
		}
		return this.hasSuccess ? 'Demande traitée avec succès' : 'Une erreur est survenue';
	}

	get ngClass() {
		return {
			'alert-danger': this.hasError,
			'alert-success': this.hasSuccess,
			'alert-warning': this.hasWarning
		};
	}

	@Input() hasError = false;
	@Input() hasSuccess = false;
	@Input() hasWarning = false;
	@Input() message = null;

	constructor() {}
}
